// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"371":"96e2cd23","381":"eca0fa51","404":"3da3e838"}[chunkId] + ".css";
};